import Payouts from "containers/Payouts"
import React from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader } from "reactstrap"

const PayoutsTab = ({ selectedProduct }) => {
  return (
    <Card>
      <CardHeader>
        <h4>Payouts</h4>
      </CardHeader>
      <CardBody>
        <Payouts
          entity_id={selectedProduct?.id}
          entity_type="product"
          price={selectedProduct?.price}
        />
      </CardBody>
    </Card>
  )
}

const mapStateToProps = state => ({
  selectedProduct: state.ProductsAndSubscriptions.selectedProduct,
})

export default connect(mapStateToProps)(PayoutsTab)
